import dayjs from 'dayjs';
import i18n from 'i18next';
import I18NextLanguageDetector from 'i18next-browser-languagedetector';
import I18NextChainedBackend, { type ChainedBackendOptions } from 'i18next-chained-backend';
import I18NextHttpBackend from 'i18next-http-backend';
import I18NextICU from 'i18next-icu';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
import { resolveURL } from 'ufo';
import { APP_VERSION, BASE_URL, IS_DEV, LOCALE_STORAGE_KEY } from '@/utils/constants';
import { transformLocaleCode } from '@/utils/language-code';

i18n
  .use(I18NextICU)
  // load translation using http with fallback -> see ./assets/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(I18NextChainedBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(I18NextLanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init<ChainedBackendOptions>({
    supportedLngs: ['en-US', 'zh-CN', 'zh-TW', 'vi-VN'],
    load: 'currentOnly',
    fallbackLng: 'en-US',
    debug: IS_DEV,
    backend: {
      backends: [I18NextHttpBackend, resourcesToBackend((lng: string) => import(`./assets/locales/${lng}.json`))],
      backendOptions: [
        {
          loadPath: () => resolveURL(BASE_URL, 'locales', `{{lng}}.${APP_VERSION.replaceAll('.', '-')}.json`),
        },
      ],
    },
    detection: {
      order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag'],
      convertDetectedLanguage: transformLocaleCode,
      lookupLocalStorage: LOCALE_STORAGE_KEY,
    },
  })
  .then(() => {
    dayjs.locale(i18n.resolvedLanguage);
  })
  .catch((error) => {
    console.error(error);
  });

export default i18n;

export const supportedLanguages = [
  {
    value: 'zh-CN',
    label: '简体中文',
  },
  {
    value: 'zh-TW',
    label: '繁體中文',
  },
  {
    value: 'en-US',
    label: 'English',
  },
  {
    value: 'vi-VN',
    label: 'Tiếng Việt',
  },
] satisfies { value: string; label: string }[];
